<template>
  <div>
    <div
      v-for="(question, index) in value"
      :key="question.id"
      class="visual-element border-t border-solit border-gray-300 bg-gray-100"
    >
      <RepeaterCollapse :wide="true" ref="repeaterCollapse">
        <template v-slot:header>
          <div class="visual-element__header py-4 pl-4">
            <span class="text-sans-md font-bold text-gray-800"
              >Domanda #{{ index + 1 }}</span
            >
          </div>
        </template>

        <template v-slot:default>
          <div class="px-4 pb-4">
            <FormRow label="Domanda" name="Domanda" rules="required">
              <v-input
                type="text"
                :name="`question-${index}`"
                v-model="question.question"
                rules="required"
              />
            </FormRow>

            <div>
              <FormRow
                v-for="(answer, i) in question.answers"
                :key="answer.id"
                :label="`Risposta #${i + 1}`"
                :name="`Risposta #${i + 1}`"
                rules="required"
              >
                <v-input
                  type="text"
                  :name="`answer-${i}`"
                  v-model="question.answers[i].answer"
                />
                <div class="mt-2">
                  <CheckboxVue
                    :name="`answer-${index}-correct`"
                    type="radio"
                    @input="selectCorrectQuestion(index, Number($event))"
                    :checked="question.answers[i].isCorrect"
                    :value="`${i}`"
                    label="Risposta corretta"
                  />
                </div>
              </FormRow>
            </div>

            <div class="py-8" v-if="question.answers.length < 4">
              <button class="btn-round-icon-alt" @click="addAnswer(question)">
                <IconPlus />
              </button>
              <span class="text-sans-base font-bold ml-2 text-gray-800"
                >Aggiungi una nuova risposta</span
              >
              <span class="text-sans-base ml-1">(minimo 2, massimo 4)</span>
            </div>
          </div>
        </template>

        <template v-slot:actions>
          <!-- Pulsante cestino -->
          <div class="visual-element__actions pr-4" v-if="value.length > 3">
            <button class="btn-round-icon-alt" @click="removeQuestion(index)">
              <IconTrash />
            </button>
          </div>
        </template>
      </RepeaterCollapse>
    </div>

    <div class="py-8">
      <button class="btn-round-icon-outline" @click="addQuestion()">
        <IconPlus />
      </button>
      <span class="text-sans-base font-bold ml-2 text-gray-800"
        >Aggiungi una domanda</span
      >
      <span class="text-sans-base ml-1">(minimo 3 domande)</span>
    </div>
  </div>
</template>

<script>
/** Icons */
import IconPlus from '@/assets/icons/icon-plus.svg'
import IconTrash from '@/assets/icons/icon-trash.svg'

/** Components */
import RepeaterCollapse from '@/components/RepeaterCollapse.vue'
import CheckboxVue from '@/components/fields/CheckboxVue.vue'

export default {
  components: {
    RepeaterCollapse,
    IconTrash,
    IconPlus,
    CheckboxVue,
  },

  props: {
    value: {
      type: Array,
      default: () => [
        {
          id: Math.random().toString(),
          question: '',
          answers: [
            {
              id: Math.random().toString(),
              answer: '',
              isCorrect: true,
            },
            {
              id: Math.random().toString(),
              answer: '',
              isCorrect: false,
            },
          ],
        },
        {
          id: Math.random().toString(),
          question: '',
          answers: [
            {
              id: Math.random().toString(),
              answer: '',
              isCorrect: true,
            },
            {
              id: Math.random().toString(),
              answer: '',
              isCorrect: false,
            },
          ],
        },
        {
          id: Math.random().toString(),
          question: '',
          answers: [
            {
              id: Math.random().toString(),
              answer: '',
              isCorrect: true,
            },
            {
              id: Math.random().toString(),
              answer: '',
              isCorrect: false,
            },
          ],
        },
      ],
    },
  },

  methods: {
    addQuestion() {
      this.$emit('input', [
        ...this.value,
        {
          id: Math.random().toString(),
          question: '',
          answers: [
            {
              id: Math.random().toString(),
              answer: '',
              isCorrect: true,
            },
            {
              id: Math.random().toString(),
              answer: '',
              isCorrect: false,
            },
          ],
        },
      ])
    },

    removeQuestion(index) {
      this.$emit(
        'input',
        this.value.filter((_, i) => i !== index),
      )
    },

    addAnswer(question) {
      this.$emit(
        'input',
        this.value.map((q, i) => {
          if (i === this.value.indexOf(question)) {
            return {
              ...q,
              answers: [
                ...q.answers,
                {
                  id: Math.random().toString(),
                  answer: '',
                  isCorrect: false,
                },
              ],
            }
          }

          return q
        }),
      )
    },

    selectCorrectQuestion(questionIndex, answerIndex) {
      this.$emit(
        'input',
        this.value.map((question, i) => ({
          ...question,
          answers: question.answers.map((answer, j) => ({
            ...answer,
            isCorrect:
              i === questionIndex && j === answerIndex
                ? true
                : i === questionIndex
                ? false
                : answer.isCorrect,
          })),
        })),
      )
    },
  },
}
</script>
